<!-- Screen Reader will announce dynamic change of document title -->
<div *ngIf="pageTitle" aria-live="assertive">
	<span [attr.aria-label]="pageTitle"></span>
</div>

<app-error></app-error>
<router-outlet></router-outlet>
<app-loader></app-loader>
